<template>
  <div class="fill-height">
    <!-- <v-img
      :lazy-src="`/img/home-cover3-sm.jpg`"
      :src="`/img/home-cover2.jpg`"
      :aspect-ratio="16/7"
      position="0 0"
    >
      <v-container fluid fill-height>
        <v-layout align-center justify-center row fill-height class="mt-5 pt-5">
  
          <home-search-form></home-search-form>
        </v-layout>
      </v-container>
    </v-img>-->
    <home-slider :images="sliderImages" />
    <div class="py-10">
      <featured></featured>
    </div>

    <v-divider></v-divider>

    <section class="white pt-10">
      <v-container class="text-center" style="max-width: 1100px">
        <h1 class="pb-3">Local Rent Online</h1>
        <p>Local Rent Online is a Local Rent Listing platform that gives opportunity to Property Managers and Owners just like you, to list the property for rent. The Seekers will easily find local listings from trusted landlords.</p>
        <p>Local Rent Online provides an equal opportunity to list the property and takes no responsibility whatsoever for the content of the listing. All the questions/requests/concerns and petitions about a listing should be directed to the listing manager or the owner of the property.</p>
        <p>Local Rent Online reserves the right to unpublish, block and delete the listing or the user when there is a direct or indirect evidence of deceit, non-truthful information or scam connected to one of the listings or the user. We intend to keep the platform clean and clear, providing useful necessary tools for a sole purpose of connecting the future renter with the listing agent/manager/owner.</p>
      </v-container>
    </section>

    <div class="py-10 features">
      <features></features>
    </div>
    <v-divider></v-divider>
    <!-- <div class="social-proofs">
      <social-proofs></social-proofs>
    </div>-->

    <app-footer></app-footer>
    <router-view></router-view>
  </div>
</template>

<script>
import Featured from "../components/frontpage/Featured";
import SocialProofs from "../components/frontpage/SocialProofs";
import HomeSearchForm from "../components/HomeSearchForm";
import Features from "../components/frontpage/Features";
import HomeSlider from "../components/frontpage/HomeSlider";
// import trans from '../trans';

export default {
  metaInfo() {
    return { title: this.trans("app.page_home", null, "Local Rent") };
  },

  components: {
    featured: Featured,
    "social-proofs": SocialProofs,
    "home-search-form": HomeSearchForm,
    features: Features,
    "home-slider": HomeSlider,
  },
  data: () => ({}),
  methods: {},
  computed: {
    sliderImages() {
      return [];
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.social-proofs,
.features {
  background-color: #fff;
}
</style>